<template>
    <b-text-field v-bind="$props" v-model="lazyValue">
        <template slot="prepend-inner">
            <v-btn small icon @click="subtract" :disabled="(min !== null && lazyValue <= min) || disabled">
                <v-icon color="error">mdi-minus</v-icon>
            </v-btn>
        </template>
        <template slot="append">
            <v-btn small icon @click="add" :disabled="(max !== null && lazyValue >= max) || disabled">
                <v-icon color="success">mdi-plus</v-icon>
            </v-btn>
        </template>
    </b-text-field>
</template>

<script>
import VuelidateMixin from "@/components/General/Form/Mixin/VuelidateMixin";
import PropsMixin from "@/components/General/Form/Mixin/PropsMixin";
import BTextField from "@/components/General/Form/BTextField";

export default {
    components: {BTextField},
    mixins: [PropsMixin, VuelidateMixin],
    props: {
        type: {
            default: 'number',
        },
        placeholder: {
            default: '',
        },
        min: {
            required: false,
            type: Number,
            default: null,
        },
        max: {
            required: false,
            type: Number,
            default: null,
        }
    },
    data() {
        return {
            isValid: false,
        }
    },
    computed: {
        lazyValue: {
            get() {
                if (!this.value) {
                    return 0;
                }

                return parseInt(this.value);
            },
            set(val) {
                this.$emit('input', val);
            }
        },
    },
    methods: {
        subtract() {
            let current = this.lazyValue;
            if (!current) {
                current = 0;
            }

            this.$emit('input', current - 1);
        },
        add() {
            let current = this.lazyValue;
            if (!current) {
                current = 0;
            }

            this.$emit('input', current + 1);
        }
    }
}
</script>
